import React from 'react';
import { MouseEvent as ReactMouseEvent } from 'react';
import { ButtonStackProps } from 'src/components/CookieSettings/ConsentBanner/ButtonStack/types';
import { AppActionTypes } from 'src/types';
import { Button } from '@nxt-costco-com/forge-components';
import { useTranslation } from 'react-i18next';
import { StyledButtonStack } from '../styles';
import { SpaceSm } from '@nxt-costco-com/forge-design-tokens';
import { useTracking } from 'react-tracking';

const analyticsAcceptAllTrackEvent = {
    functionCookie: 'Active',
    targetCookie: 'Active',
};

export const ButtonStack: React.FC<ButtonStackProps> = ({ dispatch }: ButtonStackProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'banner' });
    const { trackEvent } = useTracking();
    
    const handleClickAcceptAll = (e: ReactMouseEvent<HTMLButtonElement>) => {
        trackEvent(analyticsAcceptAllTrackEvent);
        dispatch({ type: AppActionTypes.ACCEPT_ALL, mouseEvent: e });
    };

    return (
        <StyledButtonStack direction="column" spacing={SpaceSm}>
            <Button onClick={handleClickAcceptAll} variant="primary">
                {t('buttonStack.acceptAll')}
            </Button>
            <Button onClick={() => dispatch({ type: AppActionTypes.OPEN_DRAWER })} variant="secondary">
                {t('buttonStack.reviewPreferences')}
            </Button>
        </StyledButtonStack>
    );
};
